/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function BookOpenIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="book-open"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M12 6.5L12 20" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M4.5 4.5C3.395 4.5 2.5 5.395 2.5 6.5L2.5 17C2.5 18.105 3.395 19 4.5 19L9.172 19C9.702 19 10.211 19.211 10.586 19.586L12 21L13.414 19.586C13.789 19.211 14.298 19 14.828 19L19.5 19C20.605 19 21.5 18.105 21.5 17L21.5 6.5C21.5 5.395 20.605 4.5 19.5 4.5L14.828 4.5C14.298 4.5 13.789 4.711 13.414 5.086L12 6.5L10.586 5.086C10.211 4.711 9.702 4.5 9.172 4.5L4.5 4.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
